var _path, _rect, _rect2, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDizlogoOrigin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_23_1",
    "data-name": "Component 23 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.266,
    height: 51.993,
    viewBox: "0 0 100.266 51.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M288.015,298.05v-9.386a16.6,16.6,0,1,0,.015-33.2l-7.791.122-.145-9.384,7.862-.122a25.988,25.988,0,1,1,.058,51.976Z",
    transform: "translate(-273.57 -246.074)",
    fill: "#0c78bf"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2621",
    "data-name": "Rectangle 2621",
    width: 9.086,
    height: 51.896,
    transform: "translate(46.075 0.097)",
    fill: "#0c78bf"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2622",
    "data-name": "Rectangle 2622",
    width: 9.386,
    height: 51.925,
    transform: "translate(0 0.068)",
    fill: "#0c78bf"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    transform: "translate(64.152 0.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M342.3,259.32a21.382,21.382,0,0,0-24.733-.1l-5.65-7.116a30.411,30.411,0,0,1,36.114.169Z",
    transform: "translate(-311.921 -246.243)",
    fill: "#0c78bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M329.873,280.566a28.865,28.865,0,0,1-17.952-5.859l5.65-7.116a21.379,21.379,0,0,0,24.733-.1l5.732,7.049A28.743,28.743,0,0,1,329.873,280.566Z",
    transform: "translate(-311.921 -228.88)",
    fill: "#0c78bf"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767",
    transform: "translate(69.041 15.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M330.151,257.637a9.9,9.9,0,0,0-1.118-3.275,14.924,14.924,0,0,1-1.263,3.845",
    transform: "translate(-303.858 -254.362)",
    fill: "#85bc4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M329.326,265.643a9.89,9.89,0,0,0,4.042-9.381l-2.506.6c-1.1,1.974-3.049,3.934-6.987,6.052",
    transform: "translate(-307.042 -252.809)",
    fill: "#aece71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M323.4,267.349c3.818-1.467,7.565-3.093,9.219-4.6l-5.428-2.737c-.769.414-1.612.832-2.537,1.259A48.247,48.247,0,0,0,319.559,264",
    transform: "translate(-310.569 -249.747)",
    fill: "#7bb94f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M315.148,270.606c1.816-1.7,6.646-3.066,11.6-4.985l-3.783-3.329c-7.064,4.012-7.812,8.314-7.812,8.314",
    transform: "translate(-314.174 -247.881)",
    fill: "#50a734"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M326.186,261.257a12.294,12.294,0,0,0,4.185-6.895,23.734,23.734,0,0,1-4.5,2.213",
    transform: "translate(-305.409 -254.362)",
    fill: "#aece71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M318.35,259.942c-6.126,4.921-2.878,12.5-2.878,12.5s.3-3.168,3.969-6.215",
    transform: "translate(-314.612 -249.802)",
    fill: "#50a734"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M321.577,265c.527-.265.76-.414,1.343-.681a33.018,33.018,0,0,0,6.744-3.958l-.309-4.73c-2.673,1.192-5.414,2.093-8.031,3.293",
    transform: "translate(-309.126 -253.322)",
    fill: "#85bc4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M317.9,268A36.126,36.126,0,0,1,325,263.579l-.287-6.066c-1.33.552-3.075,1.427-3.893,1.823a17.569,17.569,0,0,0-4,2.422",
    transform: "translate(-312.803 -251.787)",
    fill: "#5cae3e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDizlogoOrigin);
export default __webpack_public_path__ + "static/media/dizlogoOrigin.57c2683475ba71fa18f9baac76b42d25.svg";
export { ForwardRef as ReactComponent };